export default __webpack_public_path__ + "static/media/check.d50a58f9.mp3";